import { ApiService } from './../http/api.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { authLocalStorageToken, clearPortalSession } from '../shared/common/helper';

@Injectable()
export class SSOService {

  constructor(
    private router: Router,
    private api: ApiService,
    private oauthService: OAuthService,
  ) {
    this.configureOauthService();
  }

  private configureOauthService() {

    this.oauthService.configure(window['sso']);
    /** enable below validation only if jwks object is defined as part of oauthconfig obj */
    // this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.setStorage(sessionStorage);

    /** commented below because below resource is protected by some identity server ex: wso2 */
    // this.oauthService.loadDiscoveryDocumentAndTryLogin();

    this.oauthService.tryLogin();
  }

  public initImplicitFlow() {
    this.oauthService.initImplicitFlow();
  }

  public getAccessToken(): string {
    return this.oauthService.getAccessToken();
  }

  public getIdentityClaims(): object {
    return this.oauthService.getIdentityClaims();
  }

  public get hasValidAccessToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  public loginSSO() {
    this.api.loadingCustomOn();
    this.initImplicitFlow();
  }
  
  /**
   * Đăng xuất TOÀN CỤC (người dùng chủ động bấm): điều hướng sang endpoint logout của
   * identity server nên session SSO kết thúc và các ứng dụng khác cũng đăng xuất theo.
   * Chỉ dọn key phiên của portal - localStorage/sessionStorage dùng chung theo origin nên
   * clear() sẽ xoá lây dữ liệu của ứng dụng khác được host cùng domain.
   */
  public logout(): void {
    const idToken = JSON.parse(localStorage.getItem(authLocalStorageToken))?.idToken;
    clearPortalSession();
    if (idToken) {
      const url = `${window['sso']?.logoutUrl}?id_token_hint=${idToken}&state=state_1`;
      window.location.replace(url);
    } else {
      window.location.replace('/');
    }
  }
}